// src/hooks/useQuizData.js
import { useState, useEffect } from 'react';

const useQuizData = (targetQuizName, token) => {
    const [quizData, setQuizData] = useState(null);
    const [isLoadingQuiz, setIsLoadingQuiz] = useState(true);
    const [quizLoadError, setQuizLoadError] = useState(null);

    useEffect(() => {
        const fetchQuizData = async () => {
            setIsLoadingQuiz(true);
            setQuizLoadError(null);
            try {
                // Use the same API base URL as other hooks for consistency
                const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
                console.log('useQuizData: Using API_BASE_URL:', API_BASE_URL);

                const quizzesResponse = await fetch(`${API_BASE_URL}/api/quizzes`, {
                    headers: {
                        // 'Authorization': `Bearer ${token}`, // If endpoint is protected
                    },
                });
                if (!quizzesResponse.ok) {
                    const responseText = await quizzesResponse.text();
                    console.error('useQuizData: Quizzes response not ok:', quizzesResponse.status, responseText);
                    let errorData;
                    try {
                        errorData = JSON.parse(responseText);
                    } catch (parseError) {
                        throw new Error(`Failed to fetch quizzes list: ${quizzesResponse.status} - ${responseText.substring(0, 200)}`);
                    }
                    throw new Error(errorData.message || `Failed to fetch quizzes list: ${quizzesResponse.status}`);
                }
                const allQuizzes = await quizzesResponse.json();

                const targetQuiz = allQuizzes.find(quiz => quiz.name === targetQuizName);

                if (!targetQuiz) {
                    throw new Error(`Quiz named "${targetQuizName}" not found.`);
                }
                const currentQuizId = targetQuiz.id;

                const quizDetailResponse = await fetch(`${API_BASE_URL}/api/quizzes/${currentQuizId}`, {
                    headers: {
                        // 'Authorization': `Bearer ${token}`, // If endpoint is protected
                    },
                });

                if (!quizDetailResponse.ok) {
                    const responseText = await quizDetailResponse.text();
                    console.error('useQuizData: Quiz detail response not ok:', quizDetailResponse.status, responseText);
                    let errorData;
                    try {
                        errorData = JSON.parse(responseText);
                    } catch (parseError) {
                        throw new Error(`Failed to fetch quiz details for ID ${currentQuizId}: ${quizDetailResponse.status} - ${responseText.substring(0, 200)}`);
                    }
                    throw new Error(errorData.message || `Failed to fetch quiz details for ID ${currentQuizId}: ${quizDetailResponse.status}`);
                }
                const detailedQuizData = await quizDetailResponse.json();
                console.log(detailedQuizData)
                setQuizData(detailedQuizData);
            } catch (error) {
                console.error("useQuizData: Error fetching quiz data:", error);
                setQuizLoadError(error.message);
            } finally {
                setIsLoadingQuiz(false);
            }
        };
        fetchQuizData();
    }, [targetQuizName, token]);

    return { quizData, isLoadingQuiz, quizLoadError };
};

export default useQuizData;